<template>
    <div class="row">
        <div class="col-6">
        <div class="table-responsive">
            <table class="table quiet-table">
            <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Type</th>
                <th scope="col">Invest</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <th scope="row">1</th>
                <td>Equity</td>
                <td>5000</td>
                </tr>
                <tr>
                <th scope="row">2</th>
                <td>Debt</td>
                <td>3000</td>
                </tr>
                <tr>
                <th scope="row">3</th>
                <td>TradeCred</td>
                <td>2000</td>
                </tr>
            </tbody>
            </table>
        </div>
        </div>
    </div>
</template>
    
<script lang="ts">

//import { fetchWrapper } from '@/helpers';

export default {
    name: 'investment-plan-summary-list',
    components: {},
    data() {
    return {}
    },
    methods: {
    
    },
    mounted() {

    }
}
</script>

<style scoped>
.quiet-table thead th {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border);
}

.quiet-table tbody th,
.quiet-table tbody td {
  border-bottom: 1px solid #f1f2f4;
}

.quiet-table tbody tr:last-child th,
.quiet-table tbody tr:last-child td {
  border-bottom: none;
}
</style>